import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled from 'styled-components';
import { TableWrapperStyled } from '@insurancemenu/imenu-components-lib/dist/components/tables/general/TableWrapper/styles';

export const SubscriberInfoContentStyled = styled.div`
  & ${TableWrapperStyled} {
    min-height: 50rem;
    max-height: 50rem;

    ${breakpointsMQ4.md.down} {
      min-height: unset;
      max-height: unset;
    }
  }
`;
